export const OtpErrorMessage = ({ message }: { message: string }) => {
  return (
    <span role="alert" className="text-sm text-red-500">
      {message}
    </span>
  );
};
